import { render } from "./profileModalComponent.vue?vue&type=template&id=32307952"
import script from "./profileModalComponent.vue?vue&type=script&lang=js"
export * from "./profileModalComponent.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__